// Lightweight fetch-based API client. Avoids axios instance/interceptor issues in this env.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "ae_erp_token";

export function getToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch (_) { return null; }
}
export function setToken(t) {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch (_) { /* noop */ }
}

async function request(method, path, body, opts = {}) {
  const url = path.startsWith("http") ? path : `${API}${path}`;
  const headers = { "Content-Type": "application/json", ...(opts.headers || {}) };
  const t = getToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  const init = { method, headers };
  if (body !== undefined && body !== null) init.body = JSON.stringify(body);
  let res;
  try {
    res = await fetch(url, init);
  } catch (e) {
    const err = new Error(e?.message || "Network error");
    err.isNetwork = true;
    throw err;
  }
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch (_) { data = text; }
  if (!res.ok) {
    const err = new Error("HTTP " + res.status);
    err.response = { status: res.status, data };
    if (res.status === 401 && getToken()) setToken(null);
    throw err;
  }
  return { data, status: res.status };
}

export const api = {
  get:   (p, opts) => request("GET", p, undefined, opts),
  post:  (p, body, opts) => request("POST", p, body, opts),
  put:   (p, body, opts) => request("PUT", p, body, opts),
  patch: (p, body, opts) => request("PATCH", p, body, opts),
  delete:(p, opts) => request("DELETE", p, undefined, opts),
};

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export function inr(n) {
  const v = Number(n || 0);
  return v.toLocaleString("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch (_) { return iso; }
}
